// extracted by mini-css-extract-plugin
export default {"root":"DocCard_root__rNyAT","selected":"DocCard_selected__9DSoV"};